import { render, staticRenderFns } from "./project_tpl.vue?vue&type=template&id=61832a83&scoped=true&"
import script from "./project_tpl.vue?vue&type=script&lang=js&"
export * from "./project_tpl.vue?vue&type=script&lang=js&"
import style0 from "./project_tpl.vue?vue&type=style&index=0&id=61832a83&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61832a83",
  null
  
)

export default component.exports